var React = require('react');

function ArrowWhite (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("image",{"width":"36","height":"9","xlinkHref":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAJCAYAAABaMo5wAAAAbElEQVQ4T83UIQ6AQAxE0T8GzZXgIFxiDRiOhkegcNyFDFmyBAy6W1nTl0lbEVS2G2ABkqT1YSjIc4+1PQIT0Evaci8U9EGlgtplu41MqcyegQHoMsgVgDLhBI76EopOpyz2u0ORoKqu7O8PXaqoLDGZ2rYcAAAAAElFTkSuQmCC"}))));
}

ArrowWhite.defaultProps = {"width":"36","height":"9","viewBox":"0 0 36 9"};

module.exports = ArrowWhite;

ArrowWhite.default = ArrowWhite;
